import React from 'react';
import Checkbox from '../../../components/common/validation/fields/Checkbox';
import { classToValidate } from '../../../store/validation';
import { TApiaApiField } from '../ApiaApiHandler';

const ApiaApiCheckbox = (props: TApiaApiField) => {
  const element = React.useMemo(() => props.element, [props.element]);
  const className = React.useMemo(
    () =>
      element.class
        ? `handler__checkbox ${element.class}`
        : 'handler__checkbox',
    [element.class],
  );
  const validationRules = React.useMemo(
    () => ({
      required: element.mandatory,
      ...classToValidate(element.class),
    }),
    [element.class, element.mandatory],
  );
  const submitValueParser = React.useCallback(
    (value: string) => (value === 'on' ? 'on' : undefined),
    [],
  );
  return (
    <Checkbox
      className={className}
      name={element.id || element.name}
      label={element.text}
      title={element.title || element.text}
      value={element.value}
      disabled={element.readonly || element.disabled}
      validationRules={validationRules}
      onChange={element.onChange}
      submitValueParser={submitValueParser}
    />
  );
};

export default React.memo(ApiaApiCheckbox);
